import React from 'react';
import PropTypes from 'prop-types';
import { SFNavigationOptions } from '../utils/types';
import css from './UtilitaryLinksList.css';
import UtilitaryLink from './UtilitaryLink';

export default class UtilitaryLinksList extends React.Component {

  render() {
    const { options, currentSection } = this.props;
    return (
      <div className={css['container']}>
        <ul>
          {options.map((link, i) => <UtilitaryLink key={i} currentSection={currentSection} {...link} />)}
        </ul>
      </div>
    );
  }
}

UtilitaryLinksList.propTypes = {
  options: SFNavigationOptions.isRequired,
  currentSection: PropTypes.string
};
